import React from "react";

function MainContact() {
  return (
    <div>
      <main className="main-contact">
        <div className="container">
          <div className="row m-auto mt-5">
            <div className="col-4 text-center">
              <div className="card-contact wow animate__animated animate__fadeInUp">
                <i className="fa-solid fa-envelope" />
                <h6>البريد الالكتروني</h6>
                <p>hamdy@gmail.com</p>
                <a href="" className="btn btn-warning">
                  <i className="fa-regular fa-envelope" />
                </a>
              </div>
            </div>
            <div className="col-4 text-center">
              <div className="card-contact wow animate__animated animate__fadeInUp">
                <i className="fas fa-phone" />
                <h6>الهاتف</h6>
                <p>01001193110</p>
                <a
                  href="https://wa.me/201001193110"
                  className="btn btn-success"
                  target="_blank"
                >
                  <i className="fa-brands fa-whatsapp" />
                </a>
              </div>
            </div>
            <div className="col-4 text-center">
              <div className="card-contact wow animate__animated animate__fadeInUp">
                <i className="fa-solid fa-location-dot" />
                <h6>العنوان</h6>
                <p>يسعدنا زيارتكم</p>
                <a
                  href="https://www.google.com/maps?q=شركة+سوفت+تريد+للصناعات+الغذائية@30.40447931,30.58368146"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-info"
                >
                  <i className="fa-solid fa-location-dot" />
                </a>
              </div>
            </div>
            <div
              className="message col-12 m-auto text-center mt-5 wow animate__animated animate__fadeInUp"
              dir="rtl"
            >
              <p>
                يسعدنا التعاون مع المستوردين والوكلاء تواصل معنا الآن لمعرفة
                الأسعار وشروط التصدير 📩
              </p>
              <a
                href="https://wa.me/201001193110"
                className="btn btn-success"
                target="_blank"
              >
                تواصل معنا الان
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default MainContact;
